import * as React from "react";

import { Alignment, Classes, H3, H5, InputGroup, Navbar, Switch, Tab, TabId, Tabs,Card } from "@blueprintjs/core";
import { Example, handleBooleanChange, IExampleProps } from "@blueprintjs/docs-theme";
import CardDocuments from './CardDocuments.tsx';
import './TabsDocuments.css';

export interface ITabsExampleState {
    activePanelOnly: boolean;
    animate: boolean;
    navbarTabId: TabId;
    vertical: boolean;
    matiere_id:string;
    userid:string;
    mustrefresh:boolean;
    pageid:string;
    initialpageid:string;
    isnotdocument:string;
    dataclassesetudiants:[];
    refresh_matiere:boolean;
    data:[];
    dataformated:[];
    datacours:[];
    mustformated:boolean;
    forcematiere:string;
    coursopenwidth:Number;
}

export  class TabsDocuments extends React.PureComponent<{}, ITabsExampleState> {
    constructor(props) {
        super(props);
        console.log("TabsDocuments");
        //console.log(props);
        //this.LoadData = this.LoadData.bind(this); 
      }
    public state: ITabsExampleState = {
        activePanelOnly: false,
        animate: true,
        navbarTabId: "",
        vertical: true,
        matiere_id:"0",
        userid:"",
        pageid:'',
        initialpageid:'documents',
        isnotdocument:'none',
        mustrefresh:false,
        mustformated:false,
        refresh_matiere:false,
        dataclassesetudiants:[],
        data:[],
        dataformated:[],
        datacours:[],
        forcematiere:'',
        coursopenwidth:180
    };
    componentDidMount () {
        this.setState({userid:this.props.userid});
        this.setState({pageid:this.props.pageid});
        //this.setState({initialpageid:this.props.pageid});
        this.setState({isnotdocument:this.props.isnotdocument});
        this.setState({dataclassesetudiants:this.props.dataclassesetudiants});
        console.log(this.props.dataclassesetudiants);
        //this.LoadData(this.props.userid);
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log(prevProps);
        //console.log(prevState);
        if(this.state.data!=this.props.data){
            this.setState({data:this.props.data});
            this.setState({mustformated:true});
        }
        if(this.state.forcematiere!=this.props.forcematiere)
        {
            this.handlestate(false);
            this.setState({forcematiere:this.props.forcematiere});
            this.setState({mustformated:true});
        }
        if(this.state.mustformated==true)
        {
            var obj=[];
            this.props.data.map((item)=>{
                console.log(item);
                if(item.visible!="")
                {
                    var stvisible="_"+item.visible;
                    var publi=false;
                    if(item.visible.split("_").length>0)if(item.visible.split("_")[0]=="0")publi=true;
                    this.props.dataclassesetudiants.map((it)=>{
                        console.log(it);
                        var stidclasse="_"+it.ID+"_";
                        if(stvisible.includes(stidclasse))publi=true;
                    })
                    if(this.props.forcematiere>0)
                    {
                        if(this.props.forcematiere==item.ID)if(publi) obj.push(item);
                    }
                    else
                    if(publi) obj.push(item);
                }
            });
            this.setState({dataformated:obj});
            this.setState({mustformated:false});
            this.setState({mustrefresh:true});
            
        }
        if(this.props.pageid!=prevState.pageid){
            this.setState({pageid:this.props.pageid});
           // if(this.props.pageid==this.state.initialpageid)this.setState({mustrefresh:true});
        }
        if(this.state.dataclassesetudiants!=this.props.dataclassesetudiants)
        {
            console.log(this.props.dataclassesetudiants);
            this.setState({dataclassesetudiants:this.props.dataclassesetudiants});
        }
        if(this.state.refresh_matiere!=this.props.refresh_matiere){this.setState({refresh_matiere:this.props.refresh_matiere});this.setState({mustrefresh:true});}
        if(this.state.mustrefresh==true)
        {
            console.log("refresh_matiere");
            this.setState({mustrefresh:false});
            //on recharge les cours de la matiere en cours
            this.handleCreationCours();
        }
        //if (this.state.mustrefresh) {this.LoadData(this.props.userid);this.setState({mustrefresh:false});}
    }

LoadDataCours=(stid)=>
{
  if(stid==undefined)return;
  if(stid=="")return;
  var that=this;
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/getcours?id_matiere='+ stid); //this.state.navbarTabId)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        console.log(jsonResponse);
        jsonResponse.map((item)=>{
            if(item.publication=="")item.visible=false;
            else 
            {
                var isvisible=false;
                var tab=item.publication.split('_');
                if(tab.length>0)if(tab[0]=="0")isvisible=true;
                tab.map((item2)=>{
                    if(item2!="")
                        {
                            that.state.dataclassesetudiants.map((it)=>
                            {
                                if(it.ID==item2) isvisible=true;
                            })
                        }
                });
                item.visible=isvisible;
            }
        })
        that.setState({datacours:jsonResponse});
        //setData(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }
}
    
    handlestate=(etat)=>
    {
        if(etat)this.setState({coursopenwidth:0});else this.setState({coursopenwidth:180});
    }
    private toggleActiveOnly = handleBooleanChange(activePanelOnly => this.setState({ activePanelOnly }));
    private toggleAnimate = handleBooleanChange(animate => this.setState({ animate }));

    private toggleVertical = handleBooleanChange(vertical => this.setState({ vertical }));
    private handleNavbarTabChange = (navbarTabId: TabId) => {this.setState({ navbarTabId });this.props.handleSelectMatiere(navbarTabId); this.LoadDataCours(navbarTabId);}
    private handleCreationCours=function(){this.LoadDataCours(this.state.navbarTabId);}.bind(this);
    public render() {
        return (
            <div style={{display:this.props.isnotdocument, position:'absolute', width:'calc( 100% - 20px)',height:'auto',minHeight:'100%',padding:'10px',backgroundColor:"rgba(245,245,245,0.9", boxShadow :' 0 0 0 1px rgb(16 22 26 / 10%), 0 1px 1px rgb(16 22 26 / 20%), 0 2px 6px rgb(16 22 26 / 20%)'}}>
        
                
                {/* uncontrolled mode & each Tab has a panel: */}
                <Tabs
                    style={{width:'100%'}}
                    animate={this.state.animate}
                    id="TabsExample"
                    key={this.state.vertical ? "vertical" : "horizontal"}
                    renderActiveTabPanelOnly={this.state.activePanelOnly}
                    vertical={this.state.vertical}
                    onChange={this.handleNavbarTabChange}
                    large='true'
                >
                   {this.state.dataformated.map(p => (
                        
                        <Tab style={{display:this.state.coursopenwidth==0?'none':'flex'}} {...this.props} id={p.ID} title={p.matiere} panel={<MatierePanel {...this.props} coursopen={this.state.coursopenwidth==0} handlestate={this.handlestate}  onchildrenevent={this.handleCreationCours} id_cours={p.ID}  datacours={this.state.datacours} style={{width:'100%'}} title={p.matiere} matiere_id={p.ID} />} />
                            
                    ))}
                   
                    <Tabs.Expander />
                   
                </Tabs>
            </div>
        );
    }

    //private handleNavbarTabChange = (navbarTabId: TabId) => this.setState({ navbarTabId });
}

const MatierePanel: React.FunctionComponent = (props) => (
    <div style={{flex:'100%'}}>
         {props.datacours.map(p => (
                        
                       p.visible?<CardDocuments {...props} toolbar='false' title_lesson={p.nom} lesson_description={p.description} id_cours={p.ID}/>:null
                        
        ))}
    </div>
);



